import { device } from "shared/constants/device";
import styled from "styled-components";

export const OrderTable = styled.div`
  background:#fff;
  border-radius: 4px;
  padding: 1px;
  min-height: 400px;
  table {
    border-collapse: collapse;
    width: 100%;
    word-break: break-word;
    overflow-x: auto;
    white-space: nowrap;
  }
  tr {
    border-bottom: 1px solid rgb(244, 244, 244);
    &:hover {
      background-color: rgb(246, 252, 255);
    }
  }
  td {
    font-size: 13px;
    line-height: 20px;
    color: rgb(51, 51, 51);
  }
  th,
  td {
    min-width: 130px;
    padding: 20px 15px;
    color: rgb(120, 120, 120);
    font-size: 15px;
    font-weight: 400;
    text-align: left;
    &:last-child {
      text-align: right;
    }
  }
  @media ${device.tablet} { 
    table {
      display: block;
    }
    th,td{
      font-size: 14px;
      &:nth-child(3){
        display:none;
      }
    }
  }
`;
export const OrderDetailDesktop = styled.div`
   margin-top:20px;

  .heading {
    font-size: 19px;
    font-weight: 300;
    margin: 20px 0px 0px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    .split {
      margin: 0px 5px;
    }
    .status {
      font-weight: bolder;
    }
  }
  
`;
export const OrderDetailMobile = styled.div`
  margin-top:20px;
`;
export const OrderDetailMobileSection = styled.div`
  background:#fff;
  
  padding:10px;
  margin-bottom:10px;
  &:last-child{
    margin-bottom:0px;
  }
  .heading{
    display:flex;
    justify-content:start;
    content-center:start;
    align-items:start;
    .title{
      font-weight: bold;
      line-height: 16px;
    }
    img{
      margin-right: 10px;
    }
  }
`;
export const OrderTotalMobileSection  = styled.div`
    display:flex;
    justify-content:space-between;
    content-center:center;
    align-items:center;
    border-bottom:1px solid rgb(235,235,240);
    padding:10px;
    &:last-child{
      border-bottom:none;
    }
`
export const OrderItemProductMobileSection = styled.div`
  display:flex;
  justify-content:start;
  content-center:start;
  align-items:start;
  margin-bottom:10px;
  &:last-child{
    margin-bottom:0px;
  }
  img{
    width:100px;
    margin-right:10px;
  }
  .product-info{
    width:calc(100% - 110px);
    flex: 1 1 aut0;
    font-size:14px;
    .price{
      font-weight: bold;
    }
    .modifiers{
      span{
        font-size:12px;
        color:gray;
        &:last-child{
          &:after{
            content:""
          }
        }
        &:after{
          content:","
        }
      }
    }
  }
  @media ${device.mobileL} { 
    img{
      width:70px;
      margin-right:10px;
    }
  }
`
export const OrderDetailSection = styled.div`
  width: calc((100% - 10px) / 3);
  margin-right: 5px;
  &:last-child {
    margin-right: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    padding: 10px;
    border-radius: 4px;
    height: 100%;
    .name {
      text-transform: uppercase;
    }
  }
  .title {
    font-size: 13px;
    text-transform: uppercase;
    margin: 0px 0px 15px;
    color: rgb(36, 36, 36);
  }
  @media ${device.tablet} { 
    width: 100%;
    margin-right: 0px;
    margin-bottom: 40px;
    &:last-child{
      margin-bottom:0px;
    }
  }
`;
export const OrderDetailTable = styled.div`
  table {
    width: 100%;
    color: rgb(66, 66, 66);
    display: table;
    font-size: 13px;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    border-collapse: collapse;
    border-spacing: 0px;
    line-height: 1.5;
    word-break: break-word;
  }
  thead {
    display: table-header-group;
  }
  tfoot {
    display: table-row-group;
    tr {
      border-top: none;
      td {
        text-align: right;
        display: table-cell;
        padding: 5px 20px;
        max-width: 550px;
        min-width: 125px;
        color: rgb(36, 36, 36);
        border-bottom: none;
      }
      &:first-child {
        border-top: none;
        td {
          padding-top: 30px;
        }
      }
    }
  }
  tbody {
    tr {
      &:hover {
        background-color: rgb(246, 252, 255);
      }
    }
  }
  tr {
    display: table-row;
    padding: 10px;
  }
  td {
    font-size: 13px;
    line-height: 20px;
    color: rgb(51, 51, 51);
    .product-item {
      display: flex;
      img {
        width: 60px;
        height: 60px;
        margin-right: 15px;
      }
      .product-info {
        .product-name {
          font-size: 14px;
          color: rgb(36, 36, 36);
        }
      }
    }
  }
  th,
  td {
    display: table-cell;
    padding: 20px 15px;
    border-top: none;
    min-width: 100px;
    position: relative;
    background: 0px 0px;
    color: rgb(120, 120, 120);
    font-size: 15px;
    font-weight: 400;
    border-bottom: 1px solid rgb(244, 244, 244);
    text-align: left;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      text-align: right;
      min-width: 160px;
    }
  }
`;
